import { useTranslation } from 'react-i18next'
import { useAuth } from '@wehunt/core-web'
import { useMyGroups } from '@wehunt/clubhouse-web-wehunt'

/** The team detail page's map tab — clubhouse's `/teams/$teamId`, opened on its map. */
export function teamMapHref(teamId: string): string {
  return `/teams/${encodeURIComponent(teamId)}?tab=map`
}

/**
 * The way from a shared pin or line onto the team's own map, for a signed-in
 * member of that team.
 *
 * It lives in the shell because it joins two domains: campfire draws the shared
 * object, clubhouse owns teams and their routes, and neither may import the other.
 * Signed out it renders nothing and asks nothing; a signed-in visitor who is not
 * in the team gets nothing either — the object was shared with them, the team's
 * map was not.
 */
export function TeamMapLink({ groupId }: { groupId: string }) {
  const { t } = useTranslation('replay')
  const { state } = useAuth()
  const groups = useMyGroups()
  if (state.status !== 'signed-in') return null
  const team = groups.data?.groups.find((group) => group.id === groupId)
  if (team === undefined) return null
  return (
    <a className="wh-btn wh-btn-outline" href={teamMapHref(team.id)}>
      {t('mapLink.openTeamMap')}
    </a>
  )
}
